
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class HoldingWhitelistDialog extends SiteEntityDialog<HoldingWhitelistRow, any> {
        protected getFormKey() { return HoldingWhitelistForm.formKey; }
        protected getIdProperty() { return HoldingWhitelistRow.idProperty; }
        protected getLocalTextPrefix() { return HoldingWhitelistRow.localTextPrefix; }
        protected getNameProperty() { return HoldingWhitelistRow.nameProperty; }
        protected getService() { return HoldingWhitelistService.baseUrl; }

        protected form = new HoldingWhitelistForm(this.idPrefix);

    }
}